import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";

import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
    fontSize: 15,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    fontSize: 15,
    maxWidth: 500,
  },
}));

const HoverTooltip = (props) => {
  const { title, children, placement } = props;
  const classes = useStyles();

  return (
    <Tooltip
      title={title}
      placement={placement ? placement : "top"}
      arrow
      interactive
      classes={classes}
    >
      {children}
    </Tooltip>
  );
};

HoverTooltip.propTypes = {
  title: PropTypes.string,
  placement: PropTypes.string,
  children: PropTypes.object,
};

export default HoverTooltip;
